export function swipersInit() {

  const swiperBanners = new Swiper('.swiper-banners', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    speed: 700,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination.banners',
      clickable: true,
    },
  });

  const swiperPhones = new Swiper('.swiper-phones', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    speed: 700,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-next.phones',
      prevEl: '.swiper-button-prev.phones'
    },
  });

  const swiperNewModels = new Swiper ('.swiper-new-model', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.new-model',
      prevEl: '.swiper-button-prev.new-model',
    },
    breakpoints: {
      992: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1499: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });

  const swipersDropdownNewModels = document.querySelectorAll('.drop-model');

  swipersDropdownNewModels.forEach((drop) => {
    let category = drop.getAttribute('data-ref');

    new Swiper (drop, {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      watchOverflow: true,
      slidesPerView: 4,
      spaceBetween: 30,
      navigation: {
        nextEl: `.drop-next-${category}`,
        prevEl: `.drop-prev-${category}`,
      },
      breakpoints: {
        1499: {
          slidesPerView: 6,
          spaceBetween: 30,
        },
      },
    });
  });

  const swiperNewModelVerson = new Swiper ('.swiper-new-model-version', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.version',
      prevEl: '.swiper-button-prev.version',
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 5,
        spaceBetween: 30,
      },
      1600: {
        slidesPerView: 6,
        spaceBetween: 30,
      },
    },
  });

  const swiperPromotion = new Swiper ('.swiper-promotion', {
    slidesPerView: 1,
    watchOverflow: true,
    observer: true,
    navigation: {
      nextEl: '.swiper-button-next.promotion',
      prevEl: '.swiper-button-prev.promotion',
    },
    breakpoints: {
      900: {
        slidesPerView: 3,
        spaceBetween: 30,
      },

      1499: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });

  const swiperCategories = new Swiper ('.swiper-categories', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 3,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next.categories',
      prevEl: '.swiper-button-prev.categories',
    },
    breakpoints: {
      992: {
        slidesPerView: 8,
        spaceBetween: 10,
      },
    },
  });

  const swiperHighlightsTabs = new Swiper ('.swiper-highlights-tabs', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 3,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next.highlights-tabs',
      prevEl: '.swiper-button-prev.highlights-tabs',
    },
    breakpoints: {
      992: {
        slidesPerView: 8,
        spaceBetween: 20,
      },
    },
  });

  //Seminovos
  const swiperUsed = new Swiper('.used-cars-internal-slider-content', {
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.used',
      prevEl: '.swiper-button-prev.used',
    },
    clickable: true,
    thumbs: {
      swiper: swiperUsedThumbs,
    },
  });

  const swiperUsedModelInternalStamp = new Swiper('.used-cars-internal-stamps-slider', {
    clickable: true,
    slidesPerView: 3,
    watchOverflow: true,
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    pagination: {
      el: '.swiper-pagination.stamp',
      clickable: true
    },
  });

  const swiperUsedThumbs = new Swiper('.used-cars-internal-slider-thumbs', {
    slidesPerView: 3,
    freeMode: true,
    spaceBetween: 50,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.swiper-button-next.used-thumbs',
      prevEl: '.swiper-button-prev.used-thumbs',
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
        spaceBetween: 0,
      }
    }
  });

  const swiperUsedRelated = new Swiper('.swiper-used-related', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: '.swiper-button-next.used-related',
      prevEl: '.swiper-button-prev.used-related',
    },
    breakpoints: {
      992: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
    pagination: {
      el: '.swiper-pagination.used-related',
      dynamicBullets: true,
      clickable: true,
    }
  });
}
